import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import InstitutionProductsForm from '@/features/institution/products/components/form';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingProductsPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="products" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionProductsForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingProductsPage.displayName = 'InstitutionOnboardingProductsPage';

export default InstitutionOnboardingProductsPage;
